/**
 * @generated SignedSource<<e0249d0992f400a6526181a945012ffd>>
 * @relayHash e490775649afa10a1ac14bad8cbd94bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4181465badaa41786742045fb958487f52f56cdb498c02b73b0b7eed1a8a453f

import type { ConcreteRequest } from 'relay-runtime';
export type useListLabelsDataQuery$variables = {
  allSpaces?: boolean | null;
  cloudId: string;
  excludedLabels?: ReadonlyArray<string | null> | null;
  spaceId?: string | null;
};
export type useListLabelsDataQuery$data = {
  readonly confluence_listLabelsMacro: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    } | null> | null;
  } | null;
};
export type useListLabelsDataQuery = {
  response: useListLabelsDataQuery$data;
  variables: useListLabelsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allSpaces"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludedLabels"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceId"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "allSpaces",
        "variableName": "allSpaces"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "excludedLabels",
        "variableName": "excludedLabels"
      },
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      }
    ],
    "concreteType": "ConfluenceListLabelsEntryConnection",
    "kind": "LinkedField",
    "name": "confluence_listLabelsMacro",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceListLabelsEntry",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useListLabelsDataQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useListLabelsDataQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e490775649afa10a1ac14bad8cbd94bd",
    "id": "4181465badaa41786742045fb958487f52f56cdb498c02b73b0b7eed1a8a453f",
    "metadata": {},
    "name": "useListLabelsDataQuery",
    "operationKind": "query",
    "text": "query useListLabelsDataQuery($cloudId:ID!,$spaceId:ID,$allSpaces:Boolean,$excludedLabels:[String]){confluence_listLabelsMacro(cloudId:$cloudId,spaceId:$spaceId,allSpaces:$allSpaces,excludedLabels:$excludedLabels){nodes{name}}}"
  }
};
})();

(node as any).hash = "2c7ef1148f466dc186b067e3d9de94fc";

export default node;
